import { isUndefined as isUndefined$1 } from '../../predicate/isUndefined.mjs';

function isUndefined(x) {
    return isUndefined$1(x);
}

export { isUndefined };
